import { faEye, faEyeSlash } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { forwardRef, useState } from 'react';
import { FieldError } from 'react-hook-form';

import FormInputLayout from './FormInputLayout';

type Props = React.InputHTMLAttributes<HTMLInputElement> & {
  label: string;
  error?: FieldError;
  subtitle?: string;
  isDirty?: boolean;
};

const Component = forwardRef<HTMLInputElement, Props>((props, ref) => {
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  return (
    <div>
      <FormInputLayout
        ref={ref}
        type={isPasswordVisible ? 'text' : 'password'}
        autoComplete="new-password"
        {...props}
      >
        <button
          type="button"
          onClick={() => setIsPasswordVisible(!isPasswordVisible)}
          className="mr-2 w-7 flex-none text-xl text-gray-400"
        >
          <FontAwesomeIcon
            fixedWidth={true}
            icon={isPasswordVisible ? faEye : faEyeSlash}
          />
        </button>
      </FormInputLayout>
    </div>
  );
});

export default Component;
